import { IPolicyGPTStatusQuery, IQuery } from '@/types';
import { decodeAuthToken, gatewayAxiosInstance } from '@/utils';

export const policyGPTEnabledQuery = (): IQuery<IPolicyGPTStatusQuery> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};

  return {
    queryKey: ['persist', 'policyGPT', organisationId, memberId],
    queryFn: async () => {
      const article = await gatewayAxiosInstance.get<IPolicyGPTStatusQuery>(
        `/policygpt/framework/policygptv2/org/${organisationId}/mem/${memberId}/status`
      );
      return article.data;
    },
  };
};
